import actions from './tournament_actions';

export const TournamentDialogVisibilityState = {
  HIDE: 'HIDE',
  SHOW: 'SHOW',
  REDIRECT: 'REDIRECT',
};

export const setTournamentDialogVisibility = (tournamentDialogVisibility) => {
  return {
    type: actions.setTournamentDialogVisibilityState,
    data: {
      tournamentDialogVisibility,
    },
  };
};

export const showTournamentDialog = (routePrefix) => {
  return {
    type: actions.setTournamentDialogVisibilityState,
    data: {
      tournamentDialogVisibilityState: TournamentDialogVisibilityState.SHOW,
      tournamentRedirectRoutePrefix: routePrefix,
    },
  };
};

export const hideTournamentDialog = () => {
  return {
    type: actions.setTournamentDialogVisibilityState,
    data: {
      tournamentDialogVisibilityState: TournamentDialogVisibilityState.HIDE,
    },
  };
};

export const redirectTournamentGame = (gameId) => {
  return {
    type: actions.setTournamentDialogVisibilityState,
    data: {
      tournamentDialogVisibilityState: TournamentDialogVisibilityState.REDIRECT,
      tournamentRedirectGameId: gameId,
    },
  };
};

const INITIAL_STATE = {
  tournaments: [],
  offset: 0,
  limit: 10,
  tournamentCreators: [],
  tournamentDialogVisibilityState: TournamentDialogVisibilityState.HIDE,
  tournamentRedirectGameId: null,
  tournamentRedirectRoutePrefix: null,
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actions.getTournamentList:
      return {
        ...state,
        ...action.data,
      };
    case actions.getTournamentBanners:
      return {
        ...state,
        ...action.data,
      };
    case actions.getTournamentCreators:
      return {
        ...state,
        ...action.data,
      };
    case actions.setTournamentDialogVisibilityState:
      return {
        ...state,
        ...action.data,
      };
    default:
      return { ...state };
  }
}
